<template>
    <div>
        <Wp_nav_bar title="建群说明"></Wp_nav_bar>

        <div>
            <van-panel title="" desc="" status="">
                <div class="desc">
                    <div>
                        <span class="title">您好</span>，万品京选全国招募超级会员，前期拉人进群，自主选品转链推送，轻松赚推广金，系统管理，24小时优化，省心省力，到月分钱，超级会员需保证群里人数不低于50人！有时间去做互动，赚的会更多~
                    </div>
                    <divider></divider>
                    <div>
                        <span class="info">如需帮助请扫描下方二维码<br/>
                            或添加微信号: jingtuixiaoge0524</span>
                    </div>
                    <div style="text-align: center">
                        <img src="/images/server_qr.jpg" width="150px"/>
                    </div>
                    <divider>新超级会员需要注意事项</divider>
                    <div><span class="title">1. </span>内购群前50人拉人时间最多2天，过期将取消资格</div>
                    <div><span class="title">2. </span>拉满50人后提交资料，申请开通后台，每周二周五集中开通</div>
                    <div><span class="title">3. </span>开通后台后，京东发品员开始发品，并开始计算佣金</div>
                    <div><span class="title">4. </span>先拉家人和朋友，让他们帮您拉朋友进群，人越多，佣金才会高</div>
                    <div><span class="title">5. </span>月底结算上月佣金，周末及节假日顺延，支持微信转账</div>
                    <div><span class="title">6. </span>对超级会员唯一要求：多拉熟人朋友进群，保证群里人数不低于50人</div>
                    <div><span class="title">7. </span>为追求更高收益，超级会员可从后台找优惠商品发给消费者</div>
                    <div><span class="title">8. </span>群内人数低于50人、违反公司要求的超级会员，将停止合作</div>


                </div>

            </van-panel>

        </div>
    </div>
</template>

<script>
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    export default {
        name: "Wp_jd_request",
        components: {Wp_nav_bar},
        methods:{
            /**
             * 导航返回键
             */
            onClickBack(){
                this.$router.back();
            },
        }
    }
</script>

<style scoped>
    .title {
        font-weight: bold;
        font-size: 18px;
    }

    .info {
        font-weight: bold;
        font-size: 16px;
    }

    .desc {
        padding: 20px;
        font-size: 14px;
    }
</style>